module.exports = __webpack_public_path__ + "img/cnps.fe91833c.jpeg";